<template>
    <div :class="$style.performanceCard">
        <div :class="$style.posterContainer" @click="handleCardClick">
            <img v-if="posterImage" :src="posterImage" :alt="performance.title" :class="$style.poster" />
            <div v-else :class="$style.noPosterPlaceholder">
                <span>포스터 없음</span>
            </div>
        </div>
        <div :class="$style.content">
            <div :class="$style.info" @click="handleCardClick">
                <h4 :class="$style.title">{{ performance.title }}</h4>
                <p :class="$style.date">{{ performance.date }}</p>
                <p v-if="performance.place" :class="$style.place">{{ performance.place }}</p>
                <p v-if="performance.artist" :class="$style.artist">{{ performance.artist }}</p>
                <!-- 참여 형태 배지 -->
                <div v-if="performance.participationType === 'band' || (performance.isLineupParticipation && performance.participationType !== 'band') || performance.isCrewParticipation"
                    :class="$style.participationBadgesRow">
                    <span v-if="performance.participationType === 'band'" :class="$style.participationBadge"
                        title="밴드 멤버로 참여">
                        밴드 참여
                    </span>
                    <span v-if="performance.isLineupParticipation && performance.participationType !== 'band'"
                        :class="[$style.participationBadge, $style.lineupBadge]" title="라인업으로 참여">
                        라인업
                    </span>
                    <span v-if="performance.isCrewParticipation"
                        :class="[$style.participationBadge, $style.crewRoleBadge]" title="함께한 사람으로 참여">
                        {{ performance.crewRole }}
                    </span>
                </div>
            </div>
            <!-- 찜 버튼 -->
            <div v-if="showLikeButton" :class="$style.likeContainer">
                <button :class="[$style.likeBtn, { [$style.liked]: isLiked }]" @click.stop="handleLikeClick">
                    <img v-if="isLiked" :class="$style.likeHeart" src="@/assets/images/heart.png" alt="찜됨" />
                    <img v-else :class="$style.likeHeart" src="@/assets/images/heart_gray.png" alt="찜하기" />
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "PerformanceCard",
    props: {
        performance: {
            type: Object,
            required: true,
            validator(performance) {
                return performance && typeof performance.title === "string";
            },
        },
        isLiked: {
            type: Boolean,
            default: false,
        },
        showLikeButton: {
            type: Boolean,
            default: false,
        },
    },
    emits: ["click", "like-toggle"],
    computed: {
        posterImage() {
            // img 또는 poster 필드 지원
            return this.performance.img || this.performance.poster;
        },
    },
    methods: {
        handleCardClick() {
            this.$emit("click", this.performance.id);
        },
        handleLikeClick() {
            this.$emit("like-toggle", this.performance.id);
        },
    },
};
</script>

<style module>
.performanceCard {
    background: white;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    display: flex;
    flex-direction: column;
}

.performanceCard:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.posterContainer {
    cursor: pointer;
    width: 100%;
    height: 280px;
}

.poster {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.noPosterPlaceholder {
    width: 100%;
    height: 180px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f0f0f0;
    color: #999;
    font-size: 13px;
    font-family: "NanumSquareRoundR", sans-serif;
}

.content {
    display: flex;
    align-items: center;
    padding: 14px;
    gap: 10px;
    flex: 1;
}

.info {
    flex: 1;
    cursor: pointer;
    max-height: 100%;
    overflow-y: auto;
}

.title {
    font-size: 15px;
    font-weight: bold;
    color: #333;
    margin: 0 0 6px 0;
    font-family: "Paperlogy7", "NanumSquareRoundB", sans-serif;
}

.date {
    font-size: 13px;
    color: #666;
    margin: 0 0 4px 0;
    font-family: "Paperlogy4", "NanumSquareRoundB", sans-serif;
}

.place {
    font-size: 13px;
    color: #999;
    margin: 0;
    font-family: "Paperlogy4", "NanumSquareRoundB", sans-serif;
}

.artist {
    font-size: 12px;
    color: #999;
    margin: 0;
    font-family: "Paperlogy4", "NanumSquareRoundB", sans-serif;
}

.participationBadgesRow {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    align-items: center;
    padding: 6px 0;
    cursor: default;
}

.participationBadge {
    background: #e3f2fd;
    color: #1976d2;
    font-size: 11px;
    padding: 4px 10px;
    border-radius: 12px;
    font-family: "Paperlogy4", "NanumSquareRoundB", sans-serif;
    white-space: nowrap;
    font-weight: 500;
    border: 1px solid #bbdefb;
}

.crewRoleBadge {
    background: #f4f8ec;
    color: #5f7d2d;
    border: 1px solid #d7e6b9;
}

.lineupBadge {
    background: #ede7ff;
    color: #5f3dc4;
    border: 1px solid #d8caff;
}

.likeContainer {
    display: flex;
    align-items: center;
    justify-content: center;
}

.likeBtn {
    background: none;
    border: none;
    border-radius: 50%;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
    margin-right: 8px;
}

.likeBtn:hover {
    background: rgba(255, 107, 157, 0.1);
    transform: scale(1.1);
}

.likeBtn .likeHeart {
    width: 20px;
    height: 20px;
    transition: all 0.2s ease;
}

.likeBtn.liked {
    animation: heartBeat 0.6s ease-in-out;
}

.likeHeart {
    width: 20px;
    height: 20px;
    transition: all 0.2s ease;
}

@keyframes heartBeat {
    0% {
        transform: scale(1);
    }

    14% {
        transform: scale(1.3);
    }

    28% {
        transform: scale(1);
    }

    42% {
        transform: scale(1.3);
    }

    70% {
        transform: scale(1);
    }
}

/* ==============================================
   반응형 디자인
   - Medium: 481px ~ (기본 스타일)
   - Small: ~480px
   ============================================== */

/* Small (~480px) - 모바일 */
@media screen and (max-width: 480px) {
    .performanceCard {
        flex-direction: row !important;
        height: 100px;
    }

    .posterContainer {
        width: 85px;
        height: 120px;
    }

    .noPosterPlaceholder {
        font-size: 10px;
        height: 100%;
    }

    .content {
        padding: 8px;
        gap: 6px;
    }

    .info {
        padding: 6px;
        max-height: 88px;
        overflow-y: auto;
    }

    .title {
        font-size: 13px;
        margin-bottom: 4px;
    }

    .date {
        font-size: 11px;
        margin-bottom: 2px;
    }

    .place,
    .artist {
        font-size: 11px;
    }

    .participationBadge {
        font-size: 10px;
        padding: 2px 6px;
    }

    .likeBtn {
        width: 28px;
        height: 28px;
    }

    .likeHeart {
        width: 16px;
        height: 16px;
    }
}
</style>
